export default {"src":"/_next/static/media/file-icon.4455c0a2.svg","height":44,"width":39};